// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-success-content {
  --background: #f5f0e8;
}
.payment-success-content .container {
  max-width: 720px;
  margin: 0 auto;
  padding: 24px 20px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.logo-section {
  text-align: center;
  margin-bottom: 32px;
}
.logo-section .brand-logo {
  width: 121.15px;
  height: 115.49px;
}

.success-card {
  background: white;
  border: 2px solid #2c2c2c;
  border-radius: 8px;
  padding: 32px 24px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.thank-you-message {
  text-align: center;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e0e0e0;
}
.thank-you-message h1 {
  font-family: "AppFont", sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.5;
  color: #2c2c2c;
  margin: 0;
}

.order-details {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e0e0e0;
}
.order-details .detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.order-details .detail-row:last-child {
  margin-bottom: 0;
}
.order-details .detail-row .detail-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: "AppFont", sans-serif;
  font-size: 14px;
  color: #5c5c5c;
}
.order-details .detail-row .detail-label ion-icon {
  font-size: 18px;
  color: #5c5c5c;
}
.order-details .detail-row .detail-value {
  font-family: "AppFont", sans-serif;
  font-size: 14px;
  color: #2c2c2c;
  text-align: right;
}
.order-details .detail-row .detail-value .order-number {
  font-weight: 600;
}

.preparing-status {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #5c5c5c;
  font-size: 13px;
}
.preparing-status ion-spinner {
  width: 16px;
  height: 16px;
}

.download-receipt {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #2c2c2c;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}
.download-receipt:hover {
  background: #1a1a1a;
}
.download-receipt span {
  font-size: 13px;
  font-weight: 500;
}
.download-receipt ion-icon {
  width: 14px;
  height: 14px;
}

.order-items {
  margin-bottom: 24px;
}
.order-items .item-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}
.order-items .item-row .item-info {
  display: flex;
  gap: 8px;
  flex: 1;
}
.order-items .item-row .item-info .item-quantity {
  font-family: "AppFont", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #2c2c2c;
}
.order-items .item-row .item-info .item-name {
  font-family: "AppFont", sans-serif;
  font-size: 14px;
  color: #2c2c2c;
}
.order-items .item-row .item-price {
  font-family: "AppFont", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #2c2c2c;
  white-space: nowrap;
  margin-left: 16px;
}
.order-items .item-option {
  padding-left: 32px;
  margin-bottom: 8px;
  font-family: "AppFont", sans-serif;
  font-size: 13px;
  color: #5c5c5c;
}
.order-items .tip-row {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed #e0e0e0;
}

.miles-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed #e0e0e0;
}
.miles-row .miles-img {
  height: 18px;
  width: auto;
}
.miles-row .miles-value {
  font-family: "AppFont", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #226086;
}

.total-section {
  padding: 20px 0;
  border-top: 2px solid #2c2c2c;
  margin-bottom: 24px;
}
.total-section .total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.total-section .total-row .total-label {
  font-family: "AppFontBold", sans-serif;
  font-size: 16px;
  color: #2c2c2c;
}
.total-section .total-row .total-amount {
  font-family: "AppFontBold", sans-serif;
  font-size: 18px;
  color: #2c2c2c;
}

.review-section {
  text-align: center;
}
.review-section .review-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  background: #41403B;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
  width: 278px;
  height: 44px;
}
.review-section .review-button span {
  font-family: AppFont;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
}
.review-section .review-button:hover {
  background: #2a2a2a;
}
.review-section .review-button ion-icon {
  font-size: 18px;
  color: #ffd700;
}

.footer-message {
  text-align: center;
  margin-bottom: 16px;
  margin-top: auto;
}
.footer-message p {
  font-family: "AppFont", sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #5c5c5c;
  margin: 0;
}

.new-order-button {
  width: 100%;
  padding: 16px;
  background: #d32f2f;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.new-order-button:hover {
  background: #b71c1c;
}
.new-order-button:active {
  transform: scale(0.98);
}
.new-order-button span {
  font-family: AppFont;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
}
.new-order-button ion-spinner {
  width: 24px;
  height: 24px;
}

@media (max-width: 768px) {
  .payment-success-content .container {
    padding: 16px 16px;
  }
  .success-card {
    padding: 24px 16px;
  }
  .thank-you-message h1 {
    font-size: 16px;
  }
  .logo-section .brand-logo {
    width: 220px;
  }
}
@media (max-width: 480px) {
  .detail-row {
    align-items: flex-start !important;
    gap: 8px;
  }
  .detail-row .detail-value {
    text-align: left !important;
  }
  .order-details .detail-row .detail-label {
    font-size: 13px;
  }
  .order-details .detail-row .detail-value {
    font-size: 13px;
  }
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.loading-overlay ion-spinner {
  width: 48px;
  height: 48px;
  color: white;
}

.error-message {
  background: #ffebee;
  color: #c62828;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 16px;
  text-align: center;
  font-family: "AppFont", sans-serif;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/payment-success/payment-success.page.scss"],"names":[],"mappings":"AAEA;EACE,qBAAA;AADF;AAGE;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AADJ;;AAMA;EACE,kBAAA;EACA,mBAAA;AAHF;AAKE;EACE,eAAA;EACA,gBAAA;AAHJ;;AAQA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;AALF;;AASA;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AANF;AAQE;EACE,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AANJ;;AAWA;EACE,mBAAA;EACA,oBAAA;EACA,gCAAA;AARF;AAUE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AARJ;AAUI;EACE,gBAAA;AARN;AAWI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kCAAA;EACA,eAAA;EACA,cAAA;AATN;AAWM;EACE,eAAA;EACA,cAAA;AATR;AAaI;EACE,kCAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAXN;AAaM;EACE,gBAAA;AAXR;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AAfF;AAiBE;EACE,WAAA;EACA,YAAA;AAfJ;;AAoBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;AAjBF;AAmBE;EACE,mBAAA;AAjBJ;AAoBE;EACE,eAAA;EACA,gBAAA;AAlBJ;AAqBE;EACE,WAAA;EACA,YAAA;AAnBJ;;AAwBA;EACE,mBAAA;AArBF;AAuBE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AArBJ;AAuBI;EACE,aAAA;EACA,QAAA;EACA,OAAA;AArBN;AAuBM;EACE,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AArBR;AAwBM;EACE,kCAAA;EACA,eAAA;EACA,cAAA;AAtBR;AA0BI;EACE,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AAxBN;AA4BE;EACE,kBAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;EACA,cAAA;AA1BJ;AA6BE;EACE,gBAAA;EACA,iBAAA;EACA,8BAAA;AA3BJ;;AAgCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;AA7BF;AA+BE;EACE,YAAA;EACA,WAAA;AA7BJ;AAgCE;EACE,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA9BJ;;AAmCA;EACE,eAAA;EACA,6BAAA;EACA,mBAAA;AAhCF;AAkCE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAhCJ;AAkCI;EACE,sCAAA;EACA,eAAA;EACA,cAAA;AAhCN;AAmCI;EACE,sCAAA;EACA,eAAA;EACA,cAAA;AAjCN;;AAuCA;EACE,kBAAA;AApCF;AAsCE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,YAAA;EACA,YAAA;AApCJ;AAsCI;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AApCN;AAuCI;EACE,mBAAA;AArCN;AAwCI;EACE,eAAA;EACA,cAAA;AAtCN;;AA4CA;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;AAzCF;AA2CE;EACE,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAzCJ;;AA8CA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA3CF;AA6CE;EACE,mBAAA;AA3CJ;AA8CE;EACE,sBAAA;AA5CJ;AA+CE;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AA7CJ;AAgDE;EACE,WAAA;EACA,YAAA;AA9CJ;;AAmDA;EACE;IACE,kBAAA;EAhDF;EAmDA;IACE,kBAAA;EAjDF;EAoDA;IACE,eAAA;EAlDF;EAqDA;IACE,YAAA;EAnDF;AACF;AAsDA;EACE;IACE,kCAAA;IACA,QAAA;EApDF;EAsDE;IACE,2BAAA;EApDJ;EAwDA;IACE,eAAA;EAtDF;EAyDA;IACE,eAAA;EAvDF;AACF;AA2DA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAzDF;AA2DE;EACE,WAAA;EACA,YAAA;EACA,YAAA;AAzDJ;;AA8DA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;AA3DF","sourcesContent":["@use \"../../../theme/mixins\" as *;\n\n.payment-success-content {\n  --background: #f5f0e8;\n\n  .container {\n    max-width: 720px;\n    margin: 0 auto;\n    padding: 24px 20px;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n// Logo Section\n.logo-section {\n  text-align: center;\n  margin-bottom: 32px;\n\n  .brand-logo {\n    width: 121.15px;\n    height: 115.49px;\n  }\n}\n\n// Success Card\n.success-card {\n  background: white;\n  border: 2px solid #2c2c2c;\n  border-radius: 8px;\n  padding: 32px 24px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n// Thank You Message\n.thank-you-message {\n  text-align: center;\n  margin-bottom: 32px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid #e0e0e0;\n\n  h1 {\n    font-family: 'AppFont', sans-serif;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 1.5;\n    color: #2c2c2c;\n    margin: 0;\n  }\n}\n\n// Order Details Section\n.order-details {\n  margin-bottom: 24px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid #e0e0e0;\n\n  .detail-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    .detail-label {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      font-family: 'AppFont', sans-serif;\n      font-size: 14px;\n      color: #5c5c5c;\n\n      ion-icon {\n        font-size: 18px;\n        color: #5c5c5c;\n      }\n    }\n\n    .detail-value {\n      font-family: 'AppFont', sans-serif;\n      font-size: 14px;\n      color: #2c2c2c;\n      text-align: right;\n\n      .order-number {\n        font-weight: 600;\n      }\n    }\n  }\n}\n\n// Preparing Status\n.preparing-status {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #5c5c5c;\n  font-size: 13px;\n\n  ion-spinner {\n    width: 16px;\n    height: 16px;\n  }\n}\n\n// Download Receipt Button\n.download-receipt {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: #2c2c2c;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  &:hover {\n    background: #1a1a1a;\n  }\n\n  span {\n    font-size: 13px;\n    font-weight: 500;\n  }\n\n  ion-icon {\n    width: 14px;\n    height: 14px;\n  }\n}\n\n// Order Items Section\n.order-items {\n  margin-bottom: 24px;\n\n  .item-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 12px;\n\n    .item-info {\n      display: flex;\n      gap: 8px;\n      flex: 1;\n\n      .item-quantity {\n        font-family: 'AppFont', sans-serif;\n        font-size: 14px;\n        font-weight: 600;\n        color: #2c2c2c;\n      }\n\n      .item-name {\n        font-family: 'AppFont', sans-serif;\n        font-size: 14px;\n        color: #2c2c2c;\n      }\n    }\n\n    .item-price {\n      font-family: 'AppFont', sans-serif;\n      font-size: 14px;\n      font-weight: 600;\n      color: #2c2c2c;\n      white-space: nowrap;\n      margin-left: 16px;\n    }\n  }\n\n  .item-option {\n    padding-left: 32px;\n    margin-bottom: 8px;\n    font-family: 'AppFont', sans-serif;\n    font-size: 13px;\n    color: #5c5c5c;\n  }\n\n  .tip-row {\n    margin-top: 16px;\n    padding-top: 16px;\n    border-top: 1px dashed #e0e0e0;\n  }\n}\n\n// Miles & More Section\n.miles-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px dashed #e0e0e0;\n\n  .miles-img {\n    height: 18px;\n    width: auto;\n  }\n\n  .miles-value {\n    font-family: 'AppFont', sans-serif;\n    font-size: 14px;\n    font-weight: 600;\n    color: #226086;\n  }\n}\n\n// Total Section\n.total-section {\n  padding: 20px 0;\n  border-top: 2px solid #2c2c2c;\n  margin-bottom: 24px;\n\n  .total-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .total-label {\n      font-family: 'AppFontBold', sans-serif;\n      font-size: 16px;\n      color: #2c2c2c;\n    }\n\n    .total-amount {\n      font-family: 'AppFontBold', sans-serif;\n      font-size: 18px;\n      color: #2c2c2c;\n    }\n  }\n}\n\n// Review Section\n.review-section {\n  text-align: center;\n\n  .review-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 12px 24px;\n    background: #41403B;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background 0.2s;\n    width: 278px;\n    height: 44px;\n\n    span {\n      font-family: AppFont;\n      font-size: 14px;\n      font-weight: 700;\n      color: #fff;\n    }\n\n    &:hover {\n      background: #2a2a2a;\n    }\n\n    ion-icon {\n      font-size: 18px;\n      color: #ffd700;\n    }\n  }\n}\n\n// Footer Message\n.footer-message {\n  text-align: center;\n  margin-bottom: 16px;\n  margin-top: auto;\n\n  p {\n    font-family: 'AppFont', sans-serif;\n    font-size: 14px;\n    line-height: 1.5;\n    color: #5c5c5c;\n    margin: 0;\n  }\n}\n\n// New Order Button\n.new-order-button {\n  width: 100%;\n  padding: 16px;\n  background: #d32f2f;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    background: #b71c1c;\n  }\n\n  &:active {\n    transform: scale(0.98);\n  }\n\n  span {\n    font-family:  AppFont;\n    font-size: 14px;\n    font-weight: 700;\n    color: #fff;\n  }\n\n  ion-spinner {\n    width: 24px;\n    height: 24px;\n  }\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n  .payment-success-content .container {\n    padding: 16px 16px;\n  }\n\n  .success-card {\n    padding: 24px 16px;\n  }\n\n  .thank-you-message h1 {\n    font-size: 16px;\n  }\n\n  .logo-section .brand-logo {\n    width: 220px;\n  }\n}\n\n@media (max-width: 480px) {\n  .detail-row {\n    align-items: flex-start !important;\n    gap: 8px;\n\n    .detail-value {\n      text-align: left !important;\n    }\n  }\n\n  .order-details .detail-row .detail-label {\n    font-size: 13px;\n  }\n\n  .order-details .detail-row .detail-value {\n    font-size: 13px;\n  }\n}\n\n// Loading State\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n\n  ion-spinner {\n    width: 48px;\n    height: 48px;\n    color: white;\n  }\n}\n\n// Error State\n.error-message {\n  background: #ffebee;\n  color: #c62828;\n  padding: 12px 16px;\n  border-radius: 4px;\n  margin-bottom: 16px;\n  text-align: center;\n  font-family: 'AppFont', sans-serif;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
